import { SerializedError, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { SettingsResponse } from "../models/SettingsResponse";
import { SliceCallState } from "./sliceCallState";
import { getSettings } from "../services/settings";

export interface SettingsState {
  settings?: SettingsResponse;
  error?: SerializedError;
  loading: SliceCallState;
}

export const fetchSettings = createAsyncThunk<SettingsResponse>("settings", async (_, thunkAPI) => {
  try {
    return (await getSettings()) as SettingsResponse;
  } catch (error) {
    const err = error as SerializedError;
    return thunkAPI.rejectWithValue(err);
  }
});

const initialState: SettingsState = {
  loading: SliceCallState.idle,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSettings.pending, (state: SettingsState) => {
      state.loading = SliceCallState.pending;
    });

    builder.addCase(fetchSettings.fulfilled, (state: SettingsState, action) => {
      state.settings = action.payload;
      state.loading = SliceCallState.succeeded;
    });

    builder.addCase(fetchSettings.rejected, (state, action) => {
      state.settings = undefined;
      state.loading = SliceCallState.failed;
      state.error = action.payload as SerializedError;
      throw new Error((action.payload as SerializedError)?.message);
    });
  },
});
